import locale from './locale';

export default () => {
  return {
    firstName: {
      presetType: 'firstName',
      type: "text",
      label: __('First Name', locale),
      name: "first_name",
    },
  
    lastName: {
      presetType: 'lastName',
      type: "text",
      label: __('Last Name', locale),
      name: "last_name",
    },
    
    DOB: {
      presetType: 'DOB',
      label: __('DOB', locale),
      type: "datePicker",
      name: "dob",
      // beforeOnChange: ()=>{ }
    },

    gender: {
      presetType: 'gender',
      label: __('Gender', locale),
      type: "gender",
      name: "gender",
    },
    
    address: {
      presetType: 'address',
      label: __('Address', locale),
      type: "address",
      name: "address",
    }
  
  }

}



// WEBPACK FOOTER //
// ./src/components/Form/getPresets.js